/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DocumentState {
  Ready = 'Ready',
  WaitForSplitting = 'WaitForSplitting',
  InSplitting = 'InSplitting',
  WaitForClassification = 'WaitForClassification',
  WaitForExtraction = 'WaitForExtraction',
  InExtraction = 'InExtraction',
  WaitForExtractAssignment = 'WaitForExtractAssignment',
  InExtractAssignment = 'InExtractAssignment',
  WaitForIndexing = 'WaitForIndexing',
  InIndexing = 'InIndexing',
  WaitForMagnetAssignment = 'WaitForMagnetAssignment',
  InMagnetAssignment = 'InMagnetAssignment',
  WaitForTextExtraction = 'WaitForTextExtraction',
  WaitForStamping = 'WaitForStamping',
  WaitForOperation = 'WaitForOperation'
}
